import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import get from 'lodash/get'
import { CalendarLinksContainer } from '../../CalendarLinks'

import './style.css.scss'

function PreMeeting(props) {
  const preMeetingRef = useRef(null)

  useEffect(() => {
    if(shouldScroll()) {
      preMeetingRef.current.scrollIntoView()
    }
  }, [props])

  const startTimeText = props.eventStartTime ? `at: ${props.eventStartTime.toLocaleString("en-US")}` : "Shortly.."
  const showCalendarLinks = props.showCalendarLinks
  const calendarClassName = showCalendarLinks ? 'with-calendar-links' : ''
  const shouldScroll = () => {
    const queryParams = new URLSearchParams(window.location.search);

    return !!showCalendarLinks && !!queryParams.get('scrollToEvent')
  }

  return (
    <div ref={preMeetingRef}
         className={`live-event-pre-meeting ${calendarClassName}`}
         style={{ backgroundColor: props.themeColorHex }}>
      <div className='live-event-logo'>
        <span className="icon-zoom" />
        Live Event
      </div>
      <div className='live-event-pre-meeting-message'>
        <h1>{props.title}</h1>
        <h2>Will Start {startTimeText}</h2>
      </div>
      {!!showCalendarLinks &&
        <CalendarLinksContainer />
      }
    </div>
  )
}

PreMeeting.propTypes = {
  title: PropTypes.string.isRequired,
  eventStartTime: PropTypes.instanceOf(Date),
  themeColor: PropTypes.string,
  showCalendarLinks: PropTypes.bool
}

export default PreMeeting

